import DOMPurify from 'dompurify';

export default { // Utils - Mixins vuejs
    methods: {
        isNullOrEmpty: function(value) { // Verifica se valor é null | vazio | undefined | [] | {}
          if (Array.isArray(value)) {
              return value.length === 0;
          }
          if (Object.prototype.toString.call(value) === "[object Object]") {
              return Object.entries(value).length === 0;
          }
          
          return value == null || value === '';
        },
        toMoney(num, digits, showNull) { // FORMATA REAL
          let formattedValue;
      
          if (num) {
              formattedValue = Number(num).toLocaleString('pt-BR', { 
                  minimumFractionDigits: digits || 2, 
                  style: 'currency', 
                  currency: 'BRL' 
              });
          } else {
              formattedValue = showNull ? '' : 'R$ 0,00';
          }
      
          return formattedValue;
        },
        toPercent(num, digits){
            return num ? Number(num*100).toLocaleString('pt-BR', { minimumFractionDigits: digits || 2, maximumFractionDigits: digits || 2 }) + '%' : ''
        },
        toPercentN(num, digits){
            return num ? Number(num).toLocaleString('pt-BR', { minimumFractionDigits: digits || 2, maximumFractionDigits: digits || 2 }) + '%' : ''
        },
        formatarValores(mes, hasResult, hasZero) {
          let retorno = '';
      
          if (mes.format === 'c') {
              retorno = this.toMoney(hasResult ? hasResult.valor : mes.valor, 2, true);
          } else if (mes.format === 'n0' || mes.format === 'z') {
              retorno = hasResult ? hasResult.valor : mes.valor;
          } else if (this.isNullOrEmpty(mes.format) || mes.format !== 'c' || mes.format !== 'n0' || mes.format !== 'z') {
              retorno = this.toPercent(hasResult ? hasResult.valor : mes.valor, 2);
          }
      
          if (!retorno) {
              retorno = hasZero ? 'Vazio' : '';
          }
      
          return retorno;
        },
        paginacaoListas(data,atual,limit){
            /* 
                data  = array
                atual = number página atual
                limit = limit de itens por página
            */
            let result = []
            let items = data
            let pageActual = atual
            let limitItems = limit
            let totalPage = Math.ceil( items.length / limitItems )
            let count = ( pageActual * limitItems ) - limitItems
            let delimiter = count + limitItems

            if(pageActual <= totalPage){
                for(let i = count; i < delimiter; i++){
                    if(items[i] != null){
                        result.push(items[i])
                    }
                    count++
                }
            }
            return result || []
        },
        temAcesso: function (name, actionName) {
            const claims = JSON.parse(localStorage.getItem('user') || {}).claims;
            const isAdmin = claims.find(r => r.name === 'sysAdmin');
            
            if(isAdmin){
                return isAdmin;
            }

            if(!actionName){
                return claims.find(r => r.name === name);
            }
            
            const regra = claims.find(r => r.name === name);
            if(!regra) {
                return false;
            }
            return regra.actions.find(r => r === actionName);
        },
        mostrarApenasCluster: function (name, actionName) {
            const claims = JSON.parse(localStorage.getItem('user') || {}).claims;
            
            if(!actionName){
                return claims.find(r => r.name === name);
            }
            
            const regra = claims.find(r => r.name === name);
            if(!regra) {
                return false;
            }
            return regra.actions.find(r => r === actionName);
        },
        premiumUser: function () {
          const claims = JSON.parse(localStorage.getItem('user') || '{}').claims || [];
          return claims.some(r => r.name === 'sysPremium');
        },
        showModalPremium: (isShow) => {
            const claims = JSON.parse(localStorage.getItem('user') || {}).claims;
            const isPremium = claims.find(r => r.name === 'sysPremium');
            if(!isPremium){// só pode mostrar modal de contratar premium caso não seja premium
                document.getElementById('premium_modal').style.display = isShow === true || isShow == 'show' ? 'block' : 'none';
            }
        },
        trackingF360(vue, name, eventCategory) {
            const getUser = JSON.parse(localStorage.getItem('user')) || ''

            vue.$gtag.event(name, {
                'event_name': eventCategory || 'Trackingf360',
                'usuario_nome': getUser.user.nome || '',
                'usuario_email': getUser.user.email || '',
                'usuario_id': getUser.user._id || '',
                'grupo_nome': getUser.customer.nome || '',
                'grupo_codigo': getUser.customer.codigo || '', 
                'grupo_id': getUser.customer._id || '',  
                'grupo_tipo_perfil': 'Franqueador',
                'grupo_marcas': getUser.customer.marcasDaFranquia.join(',') || '',
                'grupo_qtd_cli': getUser.customer.qtdeGrupos || '',
                'usuario_adm' : getUser.user.isAdmin || '',
                'usuario_pagina_inicial': vue.$router.currentRoute.fullPath || window.location.href,
                'grupo_tipo_contrato': getUser.customer.contrato || ''
            });
        },
        getMarcas: function () {
            const marcas = JSON.parse(localStorage.getItem('user') || {}).customer.marcas;
            let newMarcas = marcas.map((item) => {
                item.id = item.id.toString();
                return item
            })

            if(newMarcas.length > 1) {
                newMarcas.unshift({
                    id: '0',
                    label: "Todas as marcas"
                })
            }

            return newMarcas || [];
        },
        igPermitidos() {
            const getUser = JSON.parse(localStorage.getItem('user')) || ''

            const permitidos = [
            ]

            const objetoEncontrado = permitidos?.find(item => item._id === getUser?.customer?._id);
            
            return !objetoEncontrado;
        },
        /**
         * Sanitiza o texto para uso em v-html.
         * @param {string} text
         * @returns {string}
         */
        sanitizedText(text) {
          return DOMPurify.sanitize(text);
        },

        /**
         * Sanitiza e valida URLs para uso seguro em atributos href.
         * @param {string} url
         * @returns {string}
         */
        sanitizedHref(url) {
          const urlPattern = /^(https?:\/\/|mailto:|tel:)[^\s]+$/i; // Permite URLs começando com http, https, mailto ou tel
          return urlPattern.test(url) ? url : '#'; // Retorna URL válida ou um link seguro vazio
        },

        /**
         * Gera um ID aleatório usando a API Crypto para maior segurança.
         * @param {number} length - O tamanho do ID gerado (padrão: 7).
         * @returns {string} - Um ID seguro e aleatório.
         */
        generateSecureId(length = 7) {
          const array = new Uint8Array(length);
          crypto.getRandomValues(array); // Preenche o array com valores aleatórios seguros.
          
          // Converte o array em uma string base36 (alfanumérica).
          return Array.from(array, (byte) => byte.toString(36).padStart(2, '0')).join('').substring(0, length);
        }


    }
}
